module.exports = __webpack_public_path__ + "img/top3_categories_bu.102cc1a7.png";